import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class OrderDetailsUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(req) {
        return await this.Repo.orderDetails(req);
    }
}
export default OrderDetailsUseCase;
